import { IoIosAddCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { getProductById } from "../../../service/MainService";

const RelatedProducts = ({ userDetails }) => {
  const navigate = useNavigate();

  const navigateToProductItemDetail = async (productId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const productItemDetails = await getProductById(productId, token);
      navigate(`/product/${productId}`, {
        state: { productItemDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };
  return (
    <>
      {userDetails.ProductList.length > 0 && (
        <div className="lg:px-40 mt-10 mb-10">
          <div className="flex flex-col items-center md:flex-row">
            <div className="text-2xl font-semibold border-r border-gray-400 pr-4">
              Products
            </div>
            <div className="text-gray-500 font-semibold pl-4">
              {userDetails.ProductList.length} related products
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-5">
            {userDetails.ProductList.map((product, index) => (
              <div
                className="relative cursor-pointer"
                key={index}
                onClick={() =>
                  navigateToProductItemDetail(product.productId)
                }
              >
                <img
                  src={product.image1Main}
                  alt={product.productName || `Product ${index + 1}`}
                  className="w-full h-[15rem] object-cover md:w-[20rem]"
                />
                <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 bg-black bg-opacity-50 text-white">
                  <div className="hover:border-transparent hover:rounded-lg hover:p-6 hover:mx-4 hover:my-4">
                    <IoIosAddCircleOutline
                      className="text-6xl"
                      onClick={() =>
                        navigateToProductItemDetail(product.productId)
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RelatedProducts;
